export default __webpack_public_path__ + "static/media/logo_light.33a4fbc8.svg";